import { CountryCode } from '@dayetopia/library';
import moment from 'moment';

import 'moment/locale/bg';
import 'moment/locale/en-gb';

/**
 * Get the moment locale string based on country code
 */
export const getDateLocale = (country: CountryCode | undefined): string => {
  return country === CountryCode.BG ? 'bg' : 'en-gb';
};

interface DateFormatObject {
  [key: string]: number;
}

export const parseDateFromString = (input: string, format: string) => {
  const dateFormat = format || 'yyyy-mm-dd';
  const parts = input.match(/(\d+)/g);
  let i = 0;
  const formatObject: DateFormatObject = {};

  // extract date-part indexes from the format
  dateFormat.replace(/(yyyy|dd|mm)/g, (part) => {
    formatObject[part] = i;
    i += 1;
    return part; // Return the matched part to maintain the string
  });

  if (!parts) return null;
  return new Date(parseInt(parts[formatObject.yyyy], 10), parseInt(parts[formatObject.mm], 10) - 1, parseInt(parts[formatObject.dd], 10));
};

export const calculateAge = (dateOfBirth: string) => {
  const birthday = moment(dateOfBirth, 'DD/MM/YYYY').toDate();
  const ageDifMs = Date.now() - birthday.getTime();
  const ageDate = new Date(ageDifMs); // miliseconds from epoch
  return Math.abs(ageDate.getUTCFullYear() - 1970);
};

export const checkDatesAreSameDay = (date1: Date, date2: Date) => {
  if (date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate()) {
    return true;
  }
  return false;
};

export const getDayDifference = (startDate: Date, endDate: Date) => {
  const difference = startDate.getTime() - endDate.getTime();
  const days = Math.ceil(difference / (1000 * 3600 * 24));
  return days;
};

export const getMonthDifference = (startDate: Date, endDate: Date) =>
  endDate.getMonth() - startDate.getMonth() + 12 * (endDate.getFullYear() - startDate.getFullYear());

export function formatTimestampToDate(timestamp: number | undefined) {
  if (!timestamp) {
    return '';
  }

  return moment(new Date(timestamp * 1000)).format('DD MMMM YYYY');
}

export function formatDateString(dateString: string | Date | undefined, format: string = 'DD MMM YYYY'): string | null {
  if (!dateString) {
    return null;
  }

  return moment(dateString).format(format);
}

export function getFormattedDate(timestamp: number | undefined, pendingUntilTimestamp: number | undefined) {
  if (!timestamp) {
    return '';
  }

  const timestampDate = new Date(timestamp * 1000);
  const formattedDate = moment(timestampDate).format('DD MMMM YYYY');

  if (pendingUntilTimestamp) {
    const pendingUntilDate = new Date(pendingUntilTimestamp * 1000);
    return moment(pendingUntilDate).format('DD MMMM YYYY');
  }

  return formattedDate;
}

export function subtractDaysFromDate(dateString: string, days: number): string {
  if (!dateString) {
    return '';
  }

  return moment(dateString).subtract(days, 'days').toISOString();
}

export function addDaysToDate(dateString: string, days: number): string {
  if (!dateString) {
    return '';
  }

  return moment(dateString).add(days, 'days').toISOString();
}
